// @flow

import routes from 'app/billing/routes';

export default {
  reducers: {},
  actionTypes: {},
  routes,
};
